"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseGetMockedBasketToJSON = exports.ResponseGetMockedBasketFromJSONTyped = exports.ResponseGetMockedBasketFromJSON = exports.instanceOfResponseGetMockedBasket = void 0;
/**
 * Check if a given object implements the ResponseGetMockedBasket interface.
 */
function instanceOfResponseGetMockedBasket(value) {
    var isInstance = true;
    isInstance = isInstance && "basketId" in value;
    return isInstance;
}
exports.instanceOfResponseGetMockedBasket = instanceOfResponseGetMockedBasket;
function ResponseGetMockedBasketFromJSON(json) {
    return ResponseGetMockedBasketFromJSONTyped(json, false);
}
exports.ResponseGetMockedBasketFromJSON = ResponseGetMockedBasketFromJSON;
function ResponseGetMockedBasketFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'basketId': json['basketId'],
    };
}
exports.ResponseGetMockedBasketFromJSONTyped = ResponseGetMockedBasketFromJSONTyped;
function ResponseGetMockedBasketToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'basketId': value.basketId,
    };
}
exports.ResponseGetMockedBasketToJSON = ResponseGetMockedBasketToJSON;
